/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	minimumLengthValidator,
	minimumStringLengthValidationMessage
} from '@entity/entity-formly-definitions';
import {
	IValidator
} from '@shared/interfaces/application-objects/validator.interface';
import {
	BaseRuleValidator
} from '@shared/validators/base-rule-validator.validator';

/**
 * A class representing a minimum length validator.
 *
 * @export
 * @class export class MinimumLengthValidator
 * @extends {BaseRuleValidator}
 */
export class MinimumLengthValidator
	extends BaseRuleValidator
{
	/**
	 * Creates and returns a unique instance of a minimum length validator.
	 *
	 * @returns {IValidator}
	 * A validator ready for use in a Formly layout.
	 * @memberof MinimumLengthValidator
	 */
	public create(): IValidator
	{
		return <IValidator>
			{
				expression: minimumLengthValidator,
				message: minimumStringLengthValidationMessage
			};
	}
}